/**
 * Job `years_of_experience` is a free-form string (e.g. "3 - 5", "5-6", "5+", "10").
 * Avoid appending a second "+" when the value is already a range or includes "+".
 */
export function formatJobYearsLabel(
  years: string | number | null | undefined
): string {
  if (years === null || years === undefined) return "";
  const s = String(years).trim();
  if (!s) return "";
  if (/[-–—]/.test(s) || s.includes("+")) {
    return `${s} years`;
  }
  if (/^\d+$/.test(s)) {
    return `${s}+ years`;
  }
  return `${s} years`;
}
